<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted(){
    this.$http.post('/manufacturers/list').then(res=>{
      localStorage.setItem('manufacturers',JSON.stringify(res.data))
    })
    
  }
}
</script>

<style>
  *{
    margin:0;
    padding:0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue